import { render, staticRenderFns } from "./mobileBuahKita.vue?vue&type=template&id=41c6cfbf&scoped=true&"
import script from "./mobileBuahKita.vue?vue&type=script&lang=js&"
export * from "./mobileBuahKita.vue?vue&type=script&lang=js&"
import style0 from "./mobileBuahKita.vue?vue&type=style&index=0&id=41c6cfbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c6cfbf",
  null
  
)

export default component.exports